import styled from "styled-components";

const FieldSet = styled.fieldset`
  margin: 40px 0;
  padding: 20px;
`;
export default FieldSet;
